import { render, staticRenderFns } from "./TaskProjectSelect.component.vue?vue&type=template&id=3997264d&scoped=true&"
import script from "./TaskProjectSelect.component.vue?vue&type=script&lang=js&"
export * from "./TaskProjectSelect.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskProjectSelect.component.vue?vue&type=style&index=0&id=3997264d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997264d",
  null
  
)

export default component.exports